import { datadogRum } from '@datadog/browser-rum';

const applicationId = process.env.REACT_APP_DATADOG_APPLICATION_ID || '';
const clientToken = process.env.REACT_APP_DATADOG_CLIENT_TOKEN || '';

if (applicationId && clientToken) {
  datadogRum.init({
    applicationId,
    clientToken,
    site: 'datadoghq.com',
    service: 'visão cliente',
    env: 'prod',
    version: '1',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackResources: true,
    trackUserInteractions: true,
    trackLongTasks: true
    // allowedTracingUrls: '<BACKEND_URL>',
    // defaultPrivacyLevel: 'mask-user-input',
  });
}
